export default __webpack_public_path__ + "static/media/refresh.7978eadd.svg";